import * as p from '@clack/prompts'
import type { LoadedAuthoredGeneratedSchema } from '@cli-types/core-engine/add-field.js'
import type { AddFieldCommandOptions } from '@cli-types/core-engine/commands.js'
import type { PreparedFieldInsertion } from '@cli-types/next-adapter/commands.js'
import type { SchemaOwner } from '@cli-types/preset-engine/presets.js'
import { stringifyProjectJson } from '@cli-utils/shared.js'
import { getSchemaDisplayName } from '@core-engine/schema/add-field/get-schema-display-name.js'
import { formatKind } from '../schema-prompts/format-kind.js'
import { presetIdFromOwner } from './preset-id-from-owner.js'

export function printPreview(
  loaded: LoadedAuthoredGeneratedSchema,
  owner: SchemaOwner,
  firstTimeGeneration: boolean,
  insertion: PreparedFieldInsertion,
  options: AddFieldCommandOptions
): void {
  const presetId = presetIdFromOwner(owner)
  const lines = [
    `schema: ${loaded.name} (${formatKind(loaded.kind)})`,
    `display: ${getSchemaDisplayName(loaded)}`,
    `owner: ${owner}`,
    `target: ${insertion.target.label}`,
    `order: ${insertion.order.before ? `before ${insertion.order.before}` : insertion.order.after ? `after ${insertion.order.after}` : 'end'}`,
    `migration: ${options.skipMigration ? 'skip db:push' : 'run post-generate default'}`,
    `merge conflicts: ${options.acceptGenerated || options.yes ? 'accept generated output' : 'write conflict markers'}`
  ]

  if (presetId) {
    lines.push(
      `warning: preset-owned schema; uninstalling "${presetId}" can remove this schema and generated output`
    )
  }
  if (firstTimeGeneration) {
    lines.push('warning: no per-schema snapshot manifest; generation will start from fresh output')
  }
  if (insertion.summary.length > 0) {
    lines.push(`schema integration: ${insertion.summary.join(', ')}`)
  } else {
    lines.push('schema integration: none')
  }

  p.note(
    `${lines.join('\n')}\n\n${stringifyProjectJson(insertion.field).trim()}`,
    'Add field preview'
  )
}
